import { SVGProps, Ref, forwardRef } from 'react';

export const LockClosedFilledSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 3c-.786 0-1.438.022-1.978.09.09-.478.23-.903.421-1.247C4.777 1.242 5.249.9 6 .9s1.223.342 1.557.943c.191.344.33.769.42 1.247C7.439 3.022 6.788 3 6 3M1.5 7.5c0-2.621.25-3.747 1.578-4.206C3.32 1.51 4.157 0 6 0s2.68 1.51 2.922 3.294c1.329.46 1.578 1.585 1.578 4.206 0 3.938-.562 4.5-4.5 4.5s-4.5-.562-4.5-4.5m4.05 1.25h.9v-2.5h-.9z"
            fill="currentColor"
        />
    </svg>
));
LockClosedFilledSize12Glyph.displayName = 'LockClosedFilledSize12Glyph';
